import { BaseRowData, useLegacyLoadingDataProvider } from '@adv-frontend/data-provider';
import { DistributiveOmit, genericForwardRef, genericMemo } from '@direct-frontend/stdlib';
import { LegacyGrid, LegacyGridProps } from '../LegacyGrid';
import { GridRef } from '../../../types';

/**
 * Пропсы компонента `LegacyGridStub`.
 *
 * @typeParam RowData Данные таблицы.
 */
export type LegacyGridStubProps<RowData extends BaseRowData> = DistributiveOmit<
    LegacyGridProps<RowData>,
    'dataProvider'
> & {
    /**
     * Количество рядов со скелетонами для отображения во время загрузки.
     */
    stubRowCount?: number;
};

/**
 * Скелетон грида, который можно использовать в качестве фолбека на время загрузки.
 * @deprecated Стаб для legacy {@link LegacyGrid}; для flow-based {@link Grid} используйте `GridStub`.
 **/
export const LegacyGridStub = genericMemo(
    genericForwardRef(function LegacyGridStub<RowData extends BaseRowData>(
        props: LegacyGridStubProps<RowData>,
        forwardedRef: GridRef
    ) {
        const { rowsCountState, rowsChunkSize, renderLoadMoreRow, ...otherProps } = props;
        const dataProvider = useLegacyLoadingDataProvider<RowData>(props.stubRowCount);

        return (
            <LegacyGrid {...otherProps} loadMoreRowsType="onScroll" dataProvider={dataProvider} ref={forwardedRef} />
        );
    })
);
